import { Checkbox, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePaginationContext } from "../../../common/components/functional/pagination/PaginationProvider";
import TablePaginationComponent from "../../../common/components/functional/pagination/TablePaginationComponent";
import { EntriesTableCell } from "../styles";
import { CollabsibleStates } from "../types";

type Props = {
  collabsibleStates: CollabsibleStates;
  handleSelectAllEntries: (checked: boolean) => void;
  checked: boolean;
};

const EntriesHeaders = ({
  collabsibleStates,
  handleSelectAllEntries,
  checked,
}: Props) => {
  const { t } = useTranslation("hourEntries");

  const { onPageChange, count, pageIndex, pageSize } = usePaginationContext();

  const headers = [
    { value: "checkbox" },
    { value: "week", width: "33px", align: "center" as "center" },
    { value: "date", width: "60px" },
    { value: "time", width: "184px", align: "center" as "center" },
    /*
    {
      value: "supplements",
      width: "74px",
      align: "center" as "center",
    },
    ...(collabsibleStates.supplementsOpen
      ? [{ value: "", width: "50px" }]
      : []),
      */
    {
      value: "expenses",
      width: "74px",
      align: "center" as "center",
    },
    ...(collabsibleStates.expensesOpen ? [{ value: "", width: "50px" }] : []),
    { value: "comment" },
    { value: "approval" },
  ];

  return (
    <TableHead
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        backgroundColor: "#EAEAF1",
        borderTopRightRadius: "8px",
        borderTopLeftRadius: "8px",
      }}
    >
      <TablePaginationComponent
        count={count}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPageChange={onPageChange}
      />
      <TableRow>
        {headers.map((header, index) => (
          <EntriesTableCell
            verticalAlign="middle"
            key={index}
            noBorder
            align={header.align}
            width={header.width}
            sx={{
              width: header?.width || "unset",
            }}
          >
            {header.value === "checkbox" ? (
              <Checkbox
                checked={checked}
                onChange={(e) => handleSelectAllEntries(e.target.checked)}
                sx={{ padding: 0 }}
              />
            ) : (
              t(`hourEntries:${header.value}`)
            )}
          </EntriesTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EntriesHeaders;
